module.exports = __webpack_public_path__ + "static/media/firstam_donna_lamonte.9376d7d8.jpg";